export const defaultInputValidationPaneHeaderGroupStyles = {
  marginBottom: "15px"
};